import { helper } from '@ember/component/helper';
import dayjs from 'dayjs';

export default helper(function formatDate([dateString], { format = 'MMM D, YYYY' }) {
  if (!dateString) return '';

  const date = dayjs(dateString);
  if (!date.isValid()) return dateString;

  return date.format(format);
});
